import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '@shared/components/header/header.component';
import { NavItem } from '@shared/interfaces/nav/nav-item';
import { ActivatedRoute, ParamMap, RouterOutlet } from '@angular/router';
import { MeteringPointDto } from '@app/api/dmc';
import { generateNavItems } from '@app/core/utils/generate-nav-items';
import { meteringPointNavSchema } from '@views/meteringpoint/meterpoint-details/meteringpoint-nav-items';
import { formatAddress } from '@app/core/utils/format-address';
import { TranslatePipe } from '@ngx-translate/core';
import { StateManagerService } from '@shared/state/state-manager.service';
import { HeaderService } from '@app/core/services/header.service';

@Component({
  selector: 'app-meteringpoint-details',
  imports: [
    HeaderComponent,
    RouterOutlet,
    TranslatePipe
  ],
  templateUrl: './meterpoint-details.component.html',
  styleUrl: './meterpoint-details.component.css'
})
export class MeterpointDetailsComponent implements OnInit {
  /** Navigational Tools **/
  public id!: string;

  /** Dto **/
  public meteringPoint?: MeteringPointDto;

  /** Title Address **/
  public address?: string;

  /** Nav Items **/
  public navItems: NavItem[] = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly stateManagerService: StateManagerService,
    private readonly headerService: HeaderService,
  ) { }

  public ngOnInit(): void {
    this.route.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;

      /** Primary Fetch **/
      this.stateManagerService.getMeteringPoint(this.id).subscribe((meteringPoint: MeteringPointDto) => {
        this.meteringPoint = meteringPoint;

        if (meteringPoint?.identification) {
          this.headerService.setResource(meteringPoint.identification)
        }

        this.address = meteringPoint?.installationLocationAddress ? formatAddress(meteringPoint.installationLocationAddress) : undefined;
      });

      /** Generate NavItems **/
      this.navItems = generateNavItems(meteringPointNavSchema, 'id', this.id);
    });
  }
}
